import { createElement, lazy } from "react";
import { useLocation } from "react-router-dom";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CalculatedFiltersCreateRoute = lazy(async () => {
  const [{ CalculatedFilterCreateNRO }, { CustomObjectCalculatedFilterPage }] = await Promise.all([
    import("@segments/CalculatedFilterEdit"),
    import("@segments/CustomObjectCalculatedFilter"),
  ]);

  const Route = (): React.ReactElement => {
    const { search } = useLocation();
    const isCustomObjectRoute = new URLSearchParams(search).get("type") === "DATA_OBJECTS_FILTER";

    if (isCustomObjectRoute) {
      return createElement(CustomObjectCalculatedFilterPage);
    }

    return createElement(CalculatedFilterCreateNRO);
  };

  return { default: Route };
});

export const calculatedFiltersCreateNRO: NavigationRoutingObject = {
  Component: CalculatedFiltersCreateRoute,
  componentFeatureFlippers: ["calculated_filters"],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("calculated-filters-create-heading", "Create Calculated Filter"),
  pageNameForTracking: () => "Create Calculated Filter",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-create-description", "Create a calculated filter"),
  icon: "nav-system-calculated-filters",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("calculated_filters");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_filters/:appGroupId",
};
